/* ============================================================
   UPSIL — UI interactions v2
   Carrello delegato a cart-drawer.js (Web Component).
   Questo file gestisce: quick-add, drawer mobile, header,
   reveal, sticky ATC, toast.
   ============================================================ */
(function () {
  "use strict";

  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* ============================================================
     QUICK ADD — vassoio taglie su .card__quick
     Legge le varianti dal JSON embed nella card.
     ============================================================ */
  function cardData(card) {
    if (card.__data) return card.__data;
    const el = card.querySelector(".card__json");
    try { card.__data = el ? JSON.parse(el.textContent) : { variants: [] }; }
    catch (_) { card.__data = { variants: [] }; }
    return card.__data;
  }

  function availableSizes(data, color) {
    const seen = {}, out = [];
    data.variants.forEach(v => {
      if (!v.size) return;
      const ok = color ? v.color === color : true;
      if (seen[v.size] === undefined) { seen[v.size] = false; out.push(v.size); }
      if (ok && v.available) seen[v.size] = true;
    });
    return out.map(s => ({ size: s, available: seen[s] }));
  }

  function buildSizeTray(card, tray) {
    const data  = cardData(card);
    const color = card.dataset.color || null;
    const sizes = availableSizes(data, color);
    if (!sizes.length) { tray.innerHTML = '<span class="quick-sizes__lbl">—</span>'; return; }
    tray.innerHTML = '<span class="quick-sizes__lbl">Taglia</span>' +
      sizes.map(s =>
        `<button type="button" class="quick-size" data-size="${s.size}"${s.available ? "" : " disabled"}>${s.size}</button>`
      ).join("");
  }

  function findVariant(data, size, color) {
    return data.variants.find(x => x.size === size && (color ? x.color === color : true) && x.available)
        || data.variants.find(x => x.size === size && x.available)
        || data.variants.find(x => x.size === size);
  }

  function closeTrays(except) {
    $$(".card__quick.is-open").forEach(w => { if (w !== except) w.classList.remove("is-open"); });
  }

  document.addEventListener("click", e => {
    /* swatch colore → imposta colore attivo sulla card */
    const sw = e.target.closest("[data-swatch]");
    if (sw) {
      const card = sw.closest("[data-product]");
      if (card) {
        card.dataset.color = sw.dataset.swatch;
        $$("[data-swatch]", card).forEach(s => s.classList.toggle("is-active", s === sw));
        const q    = card.querySelector(".card__quick");
        const tray = q && q.querySelector(".quick-sizes");
        if (q && q.classList.contains("is-open") && tray) buildSizeTray(card, tray);
      }
      return;
    }

    /* apri vassoio taglie — solo se NON è un quick-view button */
    const opener = e.target.closest(".quick-add");
    if (opener && !opener.hasAttribute("data-qv")) {
      const wrap = opener.closest(".card__quick");
      const card = opener.closest("[data-product]");
      if (wrap && card) {
        e.preventDefault(); e.stopPropagation();
        const tray = wrap.querySelector(".quick-sizes");
        if (tray) buildSizeTray(card, tray);
        const willOpen = !wrap.classList.contains("is-open");
        closeTrays(wrap);
        wrap.classList.toggle("is-open", willOpen);
        return;
      }
    }

    /* scegli taglia → aggiungi variante */
    const sz = e.target.closest(".quick-size");
    if (sz) {
      e.preventDefault(); e.stopPropagation();
      if (sz.disabled) return;
      const wrap = sz.closest(".card__quick");
      const card = sz.closest("[data-product]");
      if (!card) return;
      const data = cardData(card);
      const v    = findVariant(data, sz.dataset.size, card.dataset.color || null);
      if (v) window.upsilAddVariant?.(v.id, 1, { title: data.title });
      wrap.classList.remove("is-open");
      return;
    }

    if (!e.target.closest(".quick-sizes")) closeTrays(null);
  });

  /* ============================================================
     RICERCA CON SUGGERIMENTI
     La lente apre un pannello; mentre si scrive (dopo 250 ms di pausa)
     si chiedono a Shopify i prodotti e si mostrano sotto il campo.
     Ogni richiesta nuova annulla la precedente, cosi' una risposta lenta
     non sovrascrive quella giusta.
     ============================================================ */
  (function () {
    const box = $("#searchOverlay"); if (!box) return;
    const input = $("input[name=q]", box), res = $("[data-search-results]", box);
    let timer = null, ctrl = null, last = "";
    const open = () => { box.hidden = false; document.body.classList.add("search-open"); setTimeout(() => input.focus(), 30); };
    const close = () => { box.hidden = true; document.body.classList.remove("search-open"); };
    document.addEventListener("click", e => {
      if (e.target.closest("[data-search-open]")) { e.preventDefault(); open(); }
      else if (e.target.closest("[data-search-close]") || e.target === box) close();
    });
    document.addEventListener("keydown", e => { if (e.key === "Escape" && !box.hidden) close(); });
    input.addEventListener("input", () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { last = ""; res.innerHTML = ""; return; }
      timer = setTimeout(async () => {
        if (q === last) return;
        last = q;
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        res.classList.add("is-loading");
        try {
          const url = box.dataset.url + "?q=" + encodeURIComponent(q) +
            "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search";
          const r = await fetch(url, { signal: ctrl.signal });
          if (!r.ok) throw new Error(r.status);
          const doc = new DOMParser().parseFromString(await r.text(), "text/html");
          const out = doc.querySelector("#predictive-results");
          res.innerHTML = out ? out.innerHTML : "";
        } catch (err) {
          /* richiesta annullata o rete assente: resta il tasto invio, che porta alla pagina risultati */
          if (err.name !== "AbortError") res.innerHTML = "";
        } finally { res.classList.remove("is-loading"); }
      }, 250);
    });
  })();

  /* ============================================================
     TRANSIZIONE CARD → SCHEDA PRODOTTO
     La foto della card toccata prende il nome "pdp-hero": il browser la fa
     diventare la foto grande della pagina dopo. Il nome deve essere unico,
     quindi si toglie da ogni altra foto (compresa quella della scheda
     prodotto, se il click parte dai prodotti correlati).
     ============================================================ */
  document.addEventListener("click", e => {
    const link = e.target.closest(".card a[href]");
    if (!link || e.target.closest("button")) return;
    const img = link.closest(".card")?.querySelector(".card__media img");
    if (!img) return;
    $$("[data-main-img]").forEach(m => { m.style.viewTransitionName = "none"; });
    $$(".card__media img").forEach(m => { m.style.viewTransitionName = ""; });
    img.style.viewTransitionName = "pdp-hero";
  }, true);

  /* ============================================================
     DIRECT ADD [data-add]
     ============================================================ */
  document.addEventListener("click", e => {
    const btn = e.target.closest("[data-add]");
    if (!btn) return;
    e.preventDefault();
    const vid = btn.dataset.variantId;
    if (!vid) { window.upsilToast?.("Seleziona le opzioni"); return; }
    const origText  = btn.textContent;
    btn.disabled    = true;
    btn.textContent = "Aggiungendo…";
    (window.upsilAddVariant?.(vid, parseInt(btn.dataset.qty, 10) || 1, { title: btn.dataset.title }) || Promise.resolve())
      .finally(() => { btn.disabled = false; btn.textContent = origText; });
  });

  /* ============================================================
     DRAWERS / OVERLAY (menu mobile + overlay generico)
     Il carrello è gestito da cart-drawer.js.
     ============================================================ */
  const overlay = $("#overlay");

  function openEl(el) {
    if (!el) return;
    el.classList.add("is-open");
    overlay?.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeAll() {
    $$(".drawer").forEach(d => d.classList.remove("is-open"));
    overlay?.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  overlay?.addEventListener("click", closeAll);
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeAll(); });
  $$("[data-open]").forEach(b  => b.addEventListener("click", () => openEl($("#" + b.dataset.open))));
  $$("[data-close]").forEach(b => b.addEventListener("click", closeAll));
  $$("[data-cart-open]").forEach(b => b.addEventListener("click", e => {
    e.preventDefault();
    window.upsilOpenCart?.();
  }));

  /* ============================================================
     ALTEZZE DEGLI ELEMENTI FISSI IN ALTO
     Annuncio e header sono entrambi sticky: senza misurarli si
     sovrappongono, e le barre delle sezioni non sanno dove fermarsi.
     ============================================================ */
  function measureSticky() {
    const el = (s) => {
      const n = $(s);
      if (!n) return 0;
      const pos = getComputedStyle(n).position;
      return pos === "sticky" || pos === "fixed" ? n.offsetHeight : 0;
    };
    const root = document.documentElement;
    root.style.setProperty("--announce-h", el(".announce") + "px");
    root.style.setProperty("--header-h", el("#header") + "px");
  }
  measureSticky();
  window.addEventListener("resize", measureSticky, { passive: true });
  window.addEventListener("load", measureSticky);

  /* ============================================================
     STICKY HEADER (float → solid)
     ============================================================ */
  const header = $("#header");
  if (header && header.classList.contains("header--float")) {
    const announce = document.querySelector(".announce");
    function updateHeader() {
      header.classList.toggle("is-solid", window.scrollY > window.innerHeight * 0.7 - 70);
      if (announce) {
        const ab = announce.getBoundingClientRect().bottom;
        header.style.top = Math.max(0, ab) + "px";
      }
    }
    updateHeader();
    window.addEventListener("scroll", updateHeader, { passive: true });
    window.addEventListener("resize", updateHeader, { passive: true });
  }

  /* ============================================================
     STICKY MOBILE ATC (PDP)
     ============================================================ */
  const satc = $("#satc");
  if (satc) {
    const anchor = $("#atcAnchor");
    const io = new IntersectionObserver(
      ([en]) => satc.classList.toggle("show", !en.isIntersecting),
      { rootMargin: "-120px 0px 0px 0px" }
    );
    anchor && io.observe(anchor);
  }

  /* ============================================================
     REVEAL ON SCROLL
     ============================================================ */
  const revs = $$("[data-reveal]");
  if (revs.length) {
    const io = new IntersectionObserver(ents => {
      ents.forEach(en => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: .12, rootMargin: "0px 0px -8% 0px" });
    revs.forEach(el => io.observe(el));
    const revealInView = () => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      revs.forEach(el => {
        if (el.classList.contains("in")) return;
        const r = el.getBoundingClientRect();
        if (r.top < vh * 0.96 && r.bottom > 0) { el.classList.add("in"); io.unobserve(el); }
      });
    };
    requestAnimationFrame(revealInView);
    window.addEventListener("load", revealInView);
  }

  /* ============================================================
     TOAST
     ============================================================ */
  window.upsilToast = function (msg) {
    const t = $("#toast");
    if (!t) return;
    $("#toastMsg").textContent = msg;
    t.classList.add("show");
    clearTimeout(window.__tt);
    window.__tt = setTimeout(() => t.classList.remove("show"), 2200);
  };

  /* ============================================================
     MOBILE DRAWER SUBMENU
     ============================================================ */
  $$(".mmenu__toggle").forEach(function(btn) {
    var sub = btn.nextElementSibling;
    btn.addEventListener("click", function() {
      var expanded = btn.getAttribute("aria-expanded") === "true";
      // chiudi altri
      $$(".mmenu__toggle[aria-expanded='true']").forEach(function(other) {
        if (other !== btn) {
          other.setAttribute("aria-expanded", "false");
          var s = other.nextElementSibling;
          if (s) s.hidden = true;
        }
      });
      btn.setAttribute("aria-expanded", String(!expanded));
      if (sub) sub.hidden = expanded;
    });
  });

  window.dispatchEvent(new Event("upsil:ready"));
})();
